export function WordPressIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91132 0.685088 5.55585C0.00389935 7.20039 -0.17433 9.00999 0.172937 10.7558C0.520204 12.5017 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9.00001C17.9975 6.61383 17.0485 4.32611 15.3612 2.63883C13.6739 0.951543 11.3862 0.00252105 9 0V0ZM0.904766 9.00001C0.904707 7.86398 1.14454 6.74075 1.60858 5.70381L5.46857 16.2752C4.10274 15.6122 2.95089 14.5784 2.14457 13.292C1.33824 12.0055 0.90994 10.5183 0.908575 9.00001H0.904766ZM9 17.0953C8.22621 17.0951 7.45645 16.9838 6.71429 16.7648L9.14191 9.70382L11.6286 16.5181C11.6454 16.5565 11.6649 16.5937 11.6867 16.6295C10.8238 16.935 9.91533 17.0916 9 17.0924V17.0953ZM10.1152 5.20572C10.6019 5.18 11.0371 5.13238 11.0371 5.13238C11.4733 5.08096 11.4181 4.44 10.9857 4.46572C10.9857 4.46572 9.67524 4.56857 8.82857 4.56857C8.0381 4.56096 6.70191 4.46572 6.70191 4.46572C6.26572 4.44 6.21429 5.10667 6.65048 5.13238C6.65048 5.13238 7.06286 5.18381 7.49905 5.20953L8.76 8.6562L6.98858 13.9667L4.04191 5.20477C4.52953 5.17905 4.96857 5.12762 4.96857 5.12762C5.40381 5.07619 5.34953 4.43524 4.91619 4.46096C4.91619 4.46572 3.60858 4.56096 2.76 4.56096C2.60762 4.56096 2.42953 4.56096 2.23905 4.55143C2.88371 3.57347 3.73291 2.74705 4.72804 2.12922C5.72317 1.5114 6.84052 1.11688 8.00295 0.972916C9.16539 0.828946 10.3452 0.938952 11.461 1.29534C12.5768 1.65172 13.602 2.246 14.4657 3.03714C14.4314 3.03714 14.3971 3.03048 14.361 3.03048C13.5667 3.03048 13.0019 3.72286 13.0019 4.46667C13.0019 5.13334 13.3829 5.6981 13.7971 6.36477C14.1048 6.90381 14.4638 7.5962 14.4638 8.5962C14.4638 9.28858 14.1981 10.0924 13.8486 11.2124L13.0371 13.9038L10.1152 5.20572ZM16.1 5.1181C17.1092 6.96837 17.357 9.13929 16.7908 11.1694C16.2245 13.1995 14.8888 14.9287 13.0676 15.9895L15.5438 8.84667C16.0057 7.69239 16.16 6.76953 16.16 5.94858C16.1589 5.67071 16.1388 5.39324 16.1 5.1181V5.1181Z'
        fill='#464342'
      />
    </svg>
  );
}

export function WixIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7331 0.964185C15.1746 1.45422 15.011 2.23529 15.011 2.23529L13.1586 9.36403L11.6193 3.53C11.4698 2.9086 11.1993 2.14248 10.7706 1.62412C10.2255 0.963399 9.11877 0.922497 9.00079 0.922497C8.8828 0.922497 7.77373 0.963399 7.22942 1.62412C6.80152 2.14326 6.53094 2.90939 6.38149 3.53L4.84137 9.36403L2.98977 2.23608C2.98977 2.23608 2.82617 1.45501 2.26691 0.964972C1.35999 0.169744 0 0.340431 0 0.340431L3.54588 13.6627C3.54588 13.6627 4.71552 13.7468 5.30152 13.4503C6.07 13.0601 6.43576 12.7597 6.90142 10.9474C7.31594 9.33099 8.47535 4.58401 8.58311 4.24578C8.63739 4.07981 8.70503 3.68023 9 3.68023C9.30204 3.68023 9.36418 4.07903 9.41688 4.24657C9.52307 4.58479 10.6848 9.33099 11.0994 10.9482C11.565 12.7597 11.9308 13.0601 12.6993 13.4495C13.2845 13.7468 14.4541 13.6627 14.4541 13.6627L18 0.340431C18 0.340431 16.64 0.169744 15.7331 0.964185Z'
        fill='#20303C'
      />
    </svg>
  );
}

export function DrupalIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='14'
      height='18'
      viewBox='0 0 14 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.83944 3.83361C8.57068 2.56773 7.36016 1.36098 6.9999 0C6.63961 1.36098 5.4289 2.56773 4.16035 3.83361C2.25751 5.73183 0.100098 7.88318 0.100098 11.1098C0.0997614 12.0145 0.277987 12.9104 0.624594 13.7464C0.9712 14.5823 1.4794 15.3419 2.12015 15.9818C2.76091 16.6216 3.52168 17.1292 4.35899 17.4755C5.1963 17.8218 6.09376 18 7.0001 18C7.90643 18 8.80389 17.8218 9.6412 17.4755C10.4785 17.1292 11.2393 16.6216 11.88 15.9818C12.5208 15.3419 13.029 14.5823 13.3756 13.7464C13.7222 12.9104 13.9004 12.0145 13.9001 11.1098C13.9001 7.88339 11.7429 5.73183 9.83944 3.83361H9.83944ZM3.03281 12.7148C2.60973 12.7004 1.04832 10.0139 3.94499 7.15349L5.86184 9.24356C5.87829 9.25979 5.89112 9.2793 5.89947 9.30083C5.90783 9.32236 5.91152 9.34541 5.91031 9.36846C5.9091 9.39152 5.90302 9.41405 5.89246 9.43459C5.8819 9.45513 5.8671 9.47321 5.84904 9.48763C5.39164 9.95591 3.44205 11.9074 3.19973 12.5822C3.14972 12.7215 3.07667 12.7162 3.03281 12.7148ZM7.0001 16.2555C6.68846 16.2555 6.37988 16.1942 6.09196 16.0751C5.80404 15.9561 5.54243 15.7816 5.32207 15.5617C5.10171 15.3417 4.92691 15.0805 4.80765 14.7931C4.68839 14.5057 4.62701 14.1977 4.62702 13.8866C4.63578 13.3123 4.84495 12.7589 5.2185 12.322C5.6464 11.7997 6.99979 10.3307 6.99979 10.3307C6.99979 10.3307 8.33245 11.8212 8.77787 12.317C9.16589 12.7475 9.37828 13.3075 9.37319 13.8866C9.37319 14.5149 9.12317 15.1174 8.67813 15.5616C8.23309 16.0059 7.62948 16.2555 7.0001 16.2555ZM11.5422 12.4141C11.491 12.5257 11.375 12.7121 11.2184 12.7178C10.9393 12.728 10.9095 12.5852 10.7031 12.2804C10.2502 11.6113 6.29724 7.48742 5.55787 6.68987C4.90753 5.98839 5.46629 5.49384 5.72549 5.23467C6.05067 4.9095 6.99986 3.96259 6.99986 3.96259C6.99986 3.96259 9.83012 6.64312 11.0091 8.47466C12.1881 10.3062 11.7818 11.8911 11.5422 12.4141'
        fill='#009CDE'
      />
    </svg>
  );
}

export function SquareSpace({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.76614 8.43107L9.4538 2.67378C9.84022 2.28262 10.3544 2.06753 10.9024 2.06753C11.4501 2.06753 11.9643 2.28241 12.3503 2.67357L12.7934 3.12213L13.6799 2.22481L13.2368 1.77626C12.6142 1.14611 11.7853 0.799072 10.902 0.799072C10.0192 0.799277 9.19006 1.14632 8.56753 1.77666L2.87988 7.53375L3.76614 8.43107Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.376 4.58612L10.4853 3.69013L4.77099 9.4389C3.96852 10.2462 2.66285 10.2464 1.86059 9.43931C1.05812 8.63204 1.05812 7.31834 1.86059 6.51108L6.79154 1.55081L5.90088 0.655029L0.970133 5.61529C-0.323378 6.91655 -0.323378 9.03404 0.970133 10.3351C1.5956 10.9643 2.42848 11.311 3.31548 11.311C4.20269 11.311 5.03597 10.9641 5.66144 10.3349L11.376 4.58612Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0297 5.66277C16.4045 5.03354 15.5716 4.68701 14.6842 4.68701C13.797 4.68722 12.9637 5.03375 12.3382 5.66317L6.62402 11.4118L7.51428 12.3079L13.2289 6.55898C14.0315 5.75169 15.337 5.7519 16.1393 6.55877C16.5273 6.94916 16.741 7.46885 16.741 8.02261C16.741 8.57657 16.5273 9.09647 16.1393 9.48685L11.2085 14.4472L12.0992 15.343L17.0297 10.3829C18.3235 9.08158 18.3235 6.96404 17.0297 5.66277Z'
        fill='black'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.2336 7.56702L8.54603 13.3243C7.74716 14.1326 6.44786 14.133 5.64939 13.3245L5.20627 12.876L4.31982 13.7733L4.76295 14.2218C5.38546 14.852 6.21439 15.199 7.09781 15.199C7.98063 15.1988 8.80957 14.8518 9.43228 14.2214L15.1198 8.46433L14.2336 7.56702Z'
        fill='black'
      />
    </svg>
  );
}

export function WeeblyIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='18'
      height='14'
      viewBox='0 0 18 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.9354 0.0750122C13.5341 0.0750122 12.3607 1.0118 11.9962 2.41698C11.3582 0.303497 9.6949 0.0750122 8.99996 0.0750122C8.31642 0.0750122 6.65314 0.303497 6.00377 2.41698C5.65061 1.0118 4.4772 0.0750122 3.07594 0.0750122C1.35569 0.0750122 0 1.30883 0 2.88537C0 3.58225 0.170885 4.14203 0.375948 4.74752L2.72277 11.385C3.50885 13.5899 5.10378 13.9097 5.98099 13.9097C7.35946 13.9097 8.44174 13.2014 8.99996 11.9448C9.55819 13.2129 10.6405 13.9212 12.0189 13.9212C12.8961 13.9212 14.4911 13.5899 15.2772 11.385L17.6354 4.72467L17.6582 4.66755C17.6809 4.58758 17.7151 4.50761 17.7379 4.42764C17.8632 4.05064 17.9999 3.63937 17.9999 3.11385C18.0113 1.35452 16.7126 0.0750122 14.9354 0.0750122ZM16.0518 4.15346L13.6936 10.8138C13.4088 11.6249 12.9303 12.219 12.0303 12.219C11.1873 12.219 10.686 11.7506 10.4468 10.9394L9.02275 6.51827H8.98857L7.57592 10.9509C7.32529 11.762 6.82402 12.219 5.99238 12.219C5.09238 12.219 4.6139 11.6249 4.3291 10.8138L1.98227 4.19916C1.7886 3.63937 1.69746 3.29664 1.69746 2.89679C1.69746 2.27989 2.26708 1.78865 3.07594 1.78865C3.74809 1.78865 4.22656 2.23419 4.37467 2.88537L5.9582 8.16336H5.99238L7.5987 2.99961C7.81516 2.24561 8.2025 1.77722 8.99996 1.77722C9.80882 1.77722 10.1848 2.23419 10.4012 2.98819L12.0075 8.15194H12.0417L13.6253 2.87395C13.7734 2.22277 14.2518 1.77722 14.924 1.77722C15.7215 1.77722 16.3025 2.27989 16.3025 3.12528C16.3139 3.42231 16.1771 3.73076 16.0518 4.15346Z'
        fill='#3192E7'
      />
    </svg>
  );
}

export function GoogleTagManagerIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M10.5654 17.2626L7.44092 14.2159L14.1511 7.36377L17.3861 10.5342L10.5654 17.2626Z' fill='#8AB4F8' />
      <path
        d='M10.5787 3.79248L7.4655 0.613892L0.658134 7.35664C-0.219378 8.23413 -0.219378 9.65672 0.658134 10.5352L7.36323 17.2841L10.5337 14.3182L5.42513 8.94594L10.5787 3.79248Z'
        fill='#4285F4'
      />
      <path
        d='M17.341 7.40879L10.5909 0.658883C9.71236 -0.219628 8.28768 -0.219628 7.40915 0.658883C6.53061 1.53739 6.53061 2.96203 7.40915 3.84054L14.1592 10.5905C15.0378 11.469 16.4625 11.469 17.341 10.5905C18.2195 9.71194 18.2195 8.2873 17.341 7.40879Z'
        fill='#8AB4F8'
      />
      <path
        d='M8.94841 18C10.1628 18 11.1473 17.0155 11.1473 15.8012C11.1473 14.5868 10.1628 13.6023 8.94841 13.6023C7.73399 13.6023 6.74951 14.5868 6.74951 15.8012C6.74951 17.0155 7.73399 18 8.94841 18Z'
        fill='#246FDB'
      />
    </svg>
  );
}

export function OctoberCMSIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='14'
      height='18'
      viewBox='0 0 14 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7365 8.62233C13.4537 4.02358 8.42611 0.0442252 6.35495 0.000302392C4.28297 -0.04418 0.410743 4.82622 0.253959 9.77468C0.107147 14.4146 4.08186 17.5963 5.79291 18C5.84055 15.817 6.0159 7.77968 6.04526 6.84248C6.10703 4.92722 6.20149 1.94718 6.52254 1.84814C6.70674 1.79135 6.95771 3.46657 6.92696 4.45665C6.92059 4.64549 6.91838 5.25734 6.91838 6.12572C7.26491 5.77462 7.62667 5.41009 7.84661 5.19467C8.44965 4.60437 8.7164 4.67459 8.42721 5.2011C8.2491 5.52507 7.48319 6.60216 6.92004 7.3827C6.92309 8.95693 6.93029 10.9382 6.93777 12.7844C7.73304 11.857 8.70671 10.7452 9.21806 10.2508C10.2909 9.21487 10.405 9.34552 9.89838 10.433C9.5873 11.0994 8.066 12.877 6.94331 14.2789C6.95023 15.9172 6.95577 17.2944 6.95688 17.9519C9.96874 17.2919 14.0133 13.1374 13.7365 8.62233Z'
        fill='#DB6A26'
      />
    </svg>
  );
}

export function ShopifyIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='16'
      height='18'
      viewBox='0 0 16 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9545 3.46736C13.94 3.38033 13.8675 3.32232 13.795 3.32232C13.7225 3.32232 12.4462 3.29331 12.4462 3.29331C12.4462 3.29331 11.3729 2.24905 11.2714 2.14753C11.1698 2.046 10.9523 2.07501 10.8798 2.10401C10.8798 2.10401 10.6767 2.16203 10.3431 2.26356C10.2851 2.07501 10.1981 1.85745 10.0821 1.62539C9.70498 0.900213 9.13934 0.508615 8.47217 0.508615C8.42866 0.508615 8.38515 0.508615 8.32713 0.523118C8.31263 0.494111 8.28362 0.479608 8.26912 0.4506C7.97905 0.13152 7.60195 -0.0135161 7.15234 0.000987527C6.28212 0.0299948 5.4119 0.653651 4.71573 1.77043C4.2226 2.55363 3.84551 3.53988 3.72948 4.30857C2.72873 4.61314 2.03255 4.8307 2.01805 4.8452C1.51042 5.00474 1.49592 5.01925 1.4379 5.49787C1.39439 5.86046 0.0600586 16.0855 0.0600586 16.0855L11.1408 18L15.9415 16.8107C15.927 16.7962 13.969 3.55438 13.9545 3.46736ZM9.792 2.4376C9.53093 2.51012 9.24086 2.61164 8.93629 2.69866C8.93629 2.26356 8.87827 1.6399 8.67522 1.11777C9.32788 1.2483 9.64696 1.98799 9.792 2.4376ZM8.34164 2.88721C7.76149 3.06125 7.12333 3.26431 6.48517 3.45285C6.65921 2.77118 7.0073 2.08951 7.4134 1.6399C7.57294 1.48036 7.7905 1.29181 8.03706 1.17578C8.29813 1.68341 8.35614 2.39409 8.34164 2.88721ZM7.16684 0.581133C7.36989 0.581133 7.54394 0.624644 7.68897 0.711666C7.45691 0.842198 7.22486 1.01624 7.0073 1.2483C6.45616 1.84295 6.03556 2.77118 5.86151 3.6559C5.33938 3.81544 4.81725 3.97498 4.33863 4.12002C4.64321 2.72767 5.818 0.624644 7.16684 0.581133Z'
        fill='#95BF47'
      />
      <path
        d='M13.7949 3.32226C13.7224 3.32226 12.4461 3.29326 12.4461 3.29326C12.4461 3.29326 11.3728 2.24899 11.2713 2.14747C11.2277 2.10396 11.1842 2.08945 11.1262 2.07495V17.9854L15.9269 16.7961C15.9269 16.7961 13.9689 3.55432 13.9544 3.4528C13.9399 3.38028 13.8674 3.32226 13.7949 3.32226Z'
        fill='#5E8E3E'
      />
      <path
        d='M8.45762 5.78786L7.90648 7.87638C7.90648 7.87638 7.28282 7.58631 6.54314 7.64432C5.45536 7.71684 5.45536 8.39851 5.45536 8.57256C5.51338 9.50079 7.96449 9.70384 8.10953 11.8939C8.21106 13.6198 7.1958 14.7946 5.73093 14.8816C3.96149 14.9977 2.98975 13.9534 2.98975 13.9534L3.36684 12.358C3.36684 12.358 4.33858 13.0977 5.12178 13.0397C5.62941 13.0107 5.81796 12.5901 5.80345 12.3C5.73093 11.0817 3.72943 11.1542 3.5989 9.1527C3.49737 7.47028 4.59965 5.75885 7.03626 5.61381C7.979 5.5413 8.45762 5.78786 8.45762 5.78786Z'
        fill='white'
      />
    </svg>
  );
}

export function JoomlaIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.288 12.0801L3.84 11.6315C2.4 10.1896 1.984 8.1709 2.496 6.34447C1.056 6.02404 0 4.74233 0 3.20428C0 1.44192 1.44 0 3.2 0C4.8 0 6.112 1.15354 6.368 2.69159C8.096 2.27504 9.984 2.75568 11.328 4.10147L11.52 4.29373L9.152 6.66489L8.96 6.47264C8.192 5.70361 6.944 5.70361 6.176 6.47264C5.408 7.24166 5.408 8.49133 6.176 9.26036L11.488 14.5795L9.12 16.9506L6.624 14.4513L4.288 12.0801Z'
        fill='#7AC143'
      />
      <path
        d='M6.94409 9.45255L12.2561 4.13346C13.6641 2.72357 15.7121 2.27498 17.5041 2.78766C17.7281 1.21757 19.0721 0.0319824 20.6721 0.0319824C22.4321 0.0319824 23.8721 1.47391 23.8721 3.23626C23.8721 4.87044 22.6561 6.21623 21.0881 6.40849C21.6001 8.20288 21.1521 10.2216 19.7441 11.6315L19.5521 11.8237L17.2481 9.45255L17.4401 9.2603C18.2081 8.49127 18.2081 7.2416 17.4401 6.47258C16.6721 5.70355 15.4241 5.70355 14.6561 6.47258L9.34409 11.7917L6.94409 9.45255Z'
        fill='#F9A541'
      />
      <path
        d='M17.6 21.4046C15.776 21.9493 13.728 21.5328 12.288 20.0908L12.096 19.8986L14.464 17.5274L14.656 17.7197C15.424 18.4887 16.672 18.4887 17.44 17.7197C18.208 16.9507 18.208 15.701 17.44 14.932L12.128 9.61286L14.496 7.2417L19.84 12.5928C21.184 13.9386 21.664 15.8612 21.248 17.6236C22.816 17.8479 24 19.1936 24 20.7958C24 22.5581 22.56 24.0001 20.8 24.0001C19.2 23.968 17.888 22.8465 17.6 21.4046Z'
        fill='#F44321'
      />
      <path
        d='M16.672 14.7398L11.36 20.0589C9.984 21.4368 8.064 21.8854 6.336 21.4688C6.016 22.9107 4.736 23.9681 3.2 23.9681C1.44 23.9681 0 22.5262 0 20.7639C0 19.2578 1.056 17.9761 2.464 17.6557C2.016 15.8613 2.464 13.9387 3.84 12.5609L4.032 12.3687L6.4 14.7398L6.208 14.9321C5.44 15.7011 5.44 16.9508 6.208 17.7198C6.976 18.4888 8.224 18.4888 8.992 17.7198L14.304 12.4007L16.672 14.7398Z'
        fill='#5091CD'
      />
    </svg>
  );
}

export function Typo3Icon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.16359 1.86468C7.16359 0.885346 7.39452 0.560328 7.72168 0.278076C4.92268 0.605232 1.56559 1.6316 0.492177 2.93809C0.261243 3.26524 0.120117 3.77629 0.120117 4.4306C0.120117 8.58099 4.55062 18.0001 7.67464 18.0001C9.12011 18.0001 11.5577 15.6245 13.5634 12.4042C13.2962 12.4833 13.0845 12.5133 12.8044 12.5133C10.5185 12.5111 7.16359 4.52255 7.16359 1.86468Z'
        fill='#FF8700'
      />
      <path
        d='M12.1051 0C10.8927 0 10.4265 0.233072 10.4265 1.44547C10.4265 4.10335 12.8043 9.42124 14.718 9.42124C15.7893 9.42124 17.8891 5.40983 17.8891 2.09765C17.8891 0.466144 14.996 0 12.1051 0Z'
        fill='#FF8700'
      />
    </svg>
  );
}
